import React from 'react'
import FormLayout from './FormLayout'
import AdditionalPage from './WithUi/AdditionalPage'

function AdditionalInfornation() {
  return (
   <FormLayout>
   <AdditionalPage/>
   </FormLayout>
  )
}

export default AdditionalInfornation